// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { RouteIDGroup } from '../Groups/GroupsImport';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class NewsRequestMessage extends PFixMessage {
    constructor() {
        super(Message.CODE_NEWS_REQUEST_MESSAGE);
    }
    setRouteId(routeID) {
        const group = new RouteIDGroup();
        group.setRouteId(routeID);
        this.addGroup(group);
    }
    setNumber(number) {
        this.setFieldValue(FieldsFactory.FIELD_NUMBER, number);
    }
    setStartTime(startTime) {
        this.setFieldValue(FieldsFactory.FIELD_START_TIME, startTime);
    }
    setEndTime(endTime) {
        this.setFieldValue(FieldsFactory.FIELD_END_DAY_DATE, endTime);
    }
    setSymbol(value) {
        this.setFieldValue(FieldsFactory.FIELD_SYMBOL, value);
    }
    setSource(value) {
        this.setFieldValue(FieldsFactory.FIELD_SOURCE, value);
    }
    setNewsCategory(value) {
        this.setFieldValue(FieldsFactory.FIELD_NEWS_CATEGORY, value);
    }
    setPriority(value) {
        this.setFieldValue(FieldsFactory.FIELD_PRIORITY, value);
    }
    setTheme(value) {
        this.setFieldValue(FieldsFactory.FIELD_THEME, value);
    }
    setIsUpperCaseSearch(value) {
        this.setFieldValue(FieldsFactory.FIELD_IS_UPPRCASE_SEARCH, value);
    }
    setIsContentSearch(value) {
        this.setFieldValue(FieldsFactory.FIELD_IS_CONTENT_SEARCH, value);
    }
    setIsEventSearch(value) {
        this.setFieldValue(FieldsFactory.FIELD_IS_EVENT_SEARCH, value);
    }
}
